module.exports = __webpack_public_path__ + "img/prize-banner-cricket.9ccdaf7d.webp";